<template>
	<img
	 :src="lazySrc"
	 :alt="title"
	 :title="title"
	 @click="retry()"
	/>
</template>
<style scoped>
img {
	max-width: 100%;
	max-height: 100%;
}
</style>

<script>
export default {
	name: 'lazy-img',
	props: {
		title: {
			required: false,
			type: String
		},
		src: {
			required: true,
			type: String
		}
	},
	methods: {
		retry() {
			if (this.failed === true) {
				// reset image request
				this.image = new Image()
				this.image.src = this.src
				this.failed = null
				this.getImage()
			}
		},
		getImage() {
			let $this = this
			this.image = new Image()
			this.image.onload = () => {
				$this.lazySrc = this.src
				$this.failed = false
			}
			this.image.onerror = e => {
				$this.failed = true
				$this.lazySrc = require('@/../public/img/lazy-placeholder.png')
			}
			$this.image.src = $this.src // triggers load
		}
	},
	mounted() {
		this.getImage()
	},
	watch: {
		src(newVal) {
			this.src = newVal
			this.getImage()
		}
	},
	data() {
		return {
			image: new Image(),
			lazySrc: require('@/../public/img/lazy-placeholder.png'),
			failed: null
		}
	}
}
</script>